/**
 * Disclaimer
 */
import { Component, registerComponent } from 'js/component.js';

const componentName = 'disclaimer';

class Disclaimer extends Component {

    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        text: this.element.querySelector(`.${componentName}__text`),
        buttonContainer: this.element.querySelector(`.${componentName}__cta-container`),
        acceptButton: this.element.querySelector(`.${componentName}__accept-button`),
        declineButton: this.element.querySelector(`.${componentName}__decline-button`),
        downloadLink: this.element.querySelector(`.${componentName}__download`),
    };

    initButtons = () => {
        this.element.parentElement.classList.add(`${componentName}__parent`);
        this.elements.acceptButton.addEventListener('click', this.handleAccept);
        this.elements.declineButton.addEventListener('click', this.handleClose);
        this.elements.downloadLink.remove();
    };

    handleClose = () => {
        const modalDialog = this.elements.container.closest('dialog');
        if (modalDialog) {
            modalDialog.close();
        }
    };

    handleAccept = () => {
        this.elements.downloadLink.click();
        this.handleClose();
    };

    handleScroll = () => {
        const { scrollHeight, clientHeight, scrollTop } = this.elements.text;
        // re-acquire Accept button element to account for cloned button (see handleSampleCodeLinks() in search-result.js)
        const acceptButton = this.element.querySelector(`.${componentName}__accept-button`);
        // If there is zoom or display scaling, scroll and height values may not match up exactly
        if ((+scrollTop + clientHeight) >= (+scrollHeight) - 5 && +scrollHeight !== 0) {
            acceptButton.disabled = false;
        }
    };

    /**
     * Initialize Component
     */
    init() {
        this.initButtons();
        this.elements.text.addEventListener('scroll', this.handleScroll);

        const ro = new ResizeObserver(this.handleScroll);
        ro.observe(this.elements.text);
    }
}

registerComponent(`.${componentName}`, Disclaimer);
